import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserModel } from 'src/app/models/profile.model';
import { ObjectDetailsModel, ObjectDownloadInfo } from 'src/app/models/storage.model';
import { MyStorageService } from 'src/app/pages/storage/storage.service';
import { AuthStore } from 'src/app/services/auth.store';
import { environment } from 'src/environments/environment';
import {KeycloakService} from "keycloak-angular";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-onlyoffice',
  templateUrl: `./onlyoffice.component.html`,
  styles: [':host {height: 100% !important; position: absolute; width: 100%;}'],
})
export class OnlyOfficeComponent implements OnDestroy {
  subscription = new Subscription();
  docEditor: any;
  objectId!: string;
  isPublic = false;
  parentId = null;
  shareId = '';
  secretKey = null;
  dynamicWidthPx = 0;
  dynamicHeight = '';
  config: any = null;
  connector: any = null;
  officeUrl: any = `${environment.onlyOffice.url}`;
  token!: string;
  user!: UserModel;

  constructor(private activatedRoute: ActivatedRoute,
              private authStore: AuthStore,
              private myStorageService: MyStorageService,
              private keycloak: KeycloakService,
              private translateService: TranslateService) {
    this.subscription.add(
      this.activatedRoute.params.subscribe((params) => {
        this.objectId = params.id;
      }),
    );
    this.subscription.add(
      authStore.user$.subscribe((user) => {
        this.user = user;
        if (Object.keys(user).length > 0) {
          this.initializeOnlyOffice();
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initializeOnlyOffice(): void {
    let language = this.translateService.currentLang;
    let lang = 'tr-TR';
    if (language === 'ENG') {
      lang = 'en-US';
    }
    this.subscription.add(
      this.myStorageService.getObjectDetails(this.objectId).subscribe({
        next: (data) => {
          if (data) {
            const item: ObjectDetailsModel = data;
            let permissions;
            if (item.permission.toLowerCase() === 'view' || this.isPublic) {
              permissions = {
                edit: false,
                download: true,
                reader: true,
                review: false,
                print: true,
                rename: false,
                changeHistory: false,
                comment: true,
              };
            } else {
              permissions = {
                edit: true,
                download: true,
                reader: true,
                review: true,
                print: true,
                rename: false,
                changeHistory: false,
                comment: true,
              };
            }
            let officeData: any = {};

            const withTokenPublic = true;
            const url = environment.onlyOffice.url + '/s3/downloads/';
            officeData = {
              withTokenPublic,
              url,
              item,
              permissions,
              lang,
            };
            this.getOfficeInfo(officeData);
          }
        },
      }),
    );
  }

  getOfficeInfo(officeData: any): void {
    this.subscription.add(
      this.myStorageService.getDownloadId(this.objectId).subscribe({
        next: (data) => {
          if (data) {
            this.openConfigOffice(officeData, data);
          }
        },
      }),
    );
  }

  openConfigOffice(officeData: any, data: ObjectDownloadInfo): void {
    this.keycloak.getToken().then((token) => {
      const itemFileExtension = officeData.item.extension;
      const documentType = this.getType(itemFileExtension);
      const config = {
        document: {
          fileType: itemFileExtension,
          key: officeData.item.uploadId + '_' + new Date().getTime(),
          permissions: officeData.permissions,
          title: officeData.item.name,
          url: environment.apiUrl + '/api/s3/downloads/' + data.downloadId + '/single-part',
        },
        documentType,
        editorConfig: {
          customization: {
            forcesave: true,
          },
          lang: officeData.lang,
          user: {
            id: this.user.email,
            name: this.user.wholeName,
          },
          callbackUrl: environment.apiUrl + '/api/wopi/track?fileName=' + officeData.item.name + '&userAddress=' + this.user.email,
        },
        token: token,
      };

      this.subscription.add(
        this.myStorageService.getDocumentKey(this.objectId).subscribe({
          next: (data) => {
            if (data) {
              config.document.key = data.documentKey;
              this.config = config;
            }
          },
        }),
      );
    });
  }

  onDocumentReady(event: any): void {}

  getType(extension: any): string {
    if (extension === 'doc' || extension === 'docx') {
      return 'word';
    } else if (extension === 'xls' || extension === 'xlsx') {
      return 'cell';
    } else if (extension === 'ppt' || extension === 'pptx') {
      return 'slide';
    } else {
      return '';
    }
  }
}
